import React, { useContext } from 'react'
import { ModalContext } from '../../contexts/ModalContext.js'

const ModalBlocker = ({ imageSrc, imageOnly, setModalImage}) => {

	const { setIsModalOpen } = useContext(ModalContext);

	const handleModalBlocker = () => {
		setIsModalOpen(false)
		setModalImage(false)
	}

	return (
		<div className='modal-blocker' onClick={handleModalBlocker}>
			{imageOnly && 
				<div className='modal-image-wrapper'>
					<img className='modal-image' src={imageSrc} alt="" onClick={((e) => e.stopPropagation())}/>
					<i className="bi bi-x"></i>
					<h2 className='modal-image-watermark' onClick={((e) => e.stopPropagation())}>nexark</h2>
				</div>
			}
		</div>
	)
}

export default ModalBlocker